import config from 'config'
import queryString from 'query-string'

import { sliceUtmCampaign } from 'components/featured-lender-banner/LenderCard/utils'

import { containsHostname } from './urls'

export const NELNET_SLUG = 'nelnet'

/**
 * Builds the CredQual redirect URL for the Nelnet Bank row (MARK-3867).
 *
 * Nelnet is powered by CredQual, so its CTA must go direct to Nelnet via
 * `flow=core` instead of the generic credible-marketplace flow. `tile_position`
 * is intentionally omitted per the ticket.
 *
 * The widget is shared across domains (WSJ, Fox, Yahoo, Credible, ...), so the
 * Credible-specific attribution (`utm_source=credible_blog`, `utm_referrer=credible.com`)
 * is only applied when the widget runs on a Credible domain. On other domains we
 * keep the host theme / referrer so partner attribution stays correct.
 *
 * @param {Object} params
 * @param {string} params.pageUrl - Partner page URL (acts as page_url / utm_campaign).
 * @param {string} [params.theme] - Widget theme, used as utm_source off Credible.
 * @returns {string}
 */
export function getNelnetCredqualUrl({ pageUrl, theme }) {
  const onCredibleDomain = containsHostname('credible.com', pageUrl)
  const referrer = typeof document !== 'undefined' ? document.referrer : undefined

  const query = {
    lender_name: NELNET_SLUG,
    vertical: 'student-loan',
    page_url: pageUrl,
    utm_source: onCredibleDomain ? 'credible_blog' : theme,
    utm_medium: 'direct',
    utm_campaign: sliceUtmCampaign(pageUrl),
    utm_referrer: onCredibleDomain ? 'credible.com' : referrer,
    click_type: 'cta_click',
    flow: 'core',
  }

  return queryString.stringifyUrl({ url: `${config.credibleRoot}/redirect`, query })
}
